export function getAvailableRewardTypeOptions(rewardTypes, countryUser, language) {
  const options = [];

  if (countryUser === '167') {
    rewardTypes.forEach((rewardType) => {
      const id = String(rewardType.Id_MarivalRewardType);

      if (id === '1') {
        return;
      }

      if (id === '2' || id === '3') {
        if (id !== '2') {
          options.push({ value: rewardType.Id_MarivalRewardType, label: rewardType.Name });
        }
      }
    });
  }

  if (countryUser === '254' || countryUser === '40') {
    rewardTypes.forEach((rewardType) => {
      const id = String(rewardType.Id_MarivalRewardType);

      if (id === '3') {
        return;
      }

      if (id === '2' || id === '1') {
        if (language === 'esp' && id === '2') {
          return;
        }

        if (id === '1') {
          options.push({ value: rewardType.Id_MarivalRewardType, label: '$200 TANGO GC' });
        }
      }
    });
  }

  return options;
}

export function getRewardPoints(rewardTypes, id) {
  const match = rewardTypes.find((rewardType) => String(rewardType.Id_MarivalRewardType) === String(id));
  return match ? match.Points : 0;
}

export function getRewardPointsOptions(rewardTypes, id) {
  const changePoints = getRewardPoints(rewardTypes, id);

  if (Number(changePoints) === 0) {
    return [{ value: 0, label: '0', disabled: true }];
  }

  return [{ value: changePoints, label: String(changePoints), disabled: false }];
}

export function getBookingRewardTypeOptions(rewardTypes, rewardIdsCsv) {
  const rewardIds = (rewardIdsCsv || '').split(',');
  const options = [];

  rewardIds.forEach((rewardId) => {
    const match = rewardTypes.find((rewardType) => String(rewardId) === String(rewardType.Id_MarivalRewardType));

    if (match) {
      options.push({ value: match.Id_MarivalRewardType, label: match.Name });
    }
  });

  return options;
}

export function rewardTypeRequiresGuestName(rewardTypes, id) {
  const match = rewardTypes.find((rewardType) => String(rewardType.Id_MarivalRewardType) === String(id));
  return Boolean(match && match.TotalNights > 0);
}
